var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87999 1.28959L5.99999 5.16959L2.11999 1.28959C2.02741 1.19701 1.9175 1.12357 1.79653 1.07346C1.67557 1.02336 1.54592 0.997566 1.41499 0.997566C1.28406 0.997566 1.15441 1.02336 1.03345 1.07346C0.912482 1.12357 0.802571 1.19701 0.70999 1.28959C0.617408 1.38217 0.543968 1.49208 0.493863 1.61304C0.443758 1.73401 0.417969 1.86366 0.417969 1.99459C0.417969 2.12552 0.443758 2.25517 0.493863 2.37613C0.543968 2.49709 0.617408 2.60701 0.70999 2.69959L5.29999 7.28959C5.3925 7.38229 5.50239 7.45584 5.62337 7.50602C5.74434 7.5562 5.87402 7.58203 6.00499 7.58203C6.13596 7.58203 6.26564 7.5562 6.38661 7.50602C6.50759 7.45584 6.61748 7.38229 6.70999 7.28959L11.3 2.69959C11.69 2.30959 11.69 1.67959 11.3 1.28959C10.91 0.909587 10.27 0.899587 9.87999 1.28959Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyArrow);
export default __webpack_public_path__ + "static/media/greyArrow.8277a16e80dc3cd12faa46350303db65.svg";
export { ForwardRef as ReactComponent };